// Mock data for CENID website

export const carouselImages = [
  {
    id: 1,
    url: 'https://recursos.cenid.org/img_cenid/servicios/ufp.jpeg',
    alt: 'UFP CENID',
    link: '#'
  },
  {
    id: 2,
    url: 'https://recursos.cenid.org/img_cenid/servicios/15anioscenid.jpeg',
    alt: 'CENID 15 años',
    link: '#'
  },
  {
    id: 3,
    url: 'https://recursos.cenid.org/img_cenid/proyecto_catedra.jpeg',
    alt: 'Proyecto Cátedra UNESCO',
    link: '/proyecto-unitwin'
  },
  {
    id: 4,
    url: 'https://recursos.cenid.org/img_cenid/servicios/revistas.jpeg',
    alt: 'Revistas Electrónicas',
    link: '/revistas'
  },
  {
    id: 5,
    url: 'https://recursos.cenid.org/img_cenid/servicios/postdoctorados.jpeg',
    alt: 'Postdoctorados',
    link: '/postdoctorados'
  }
];

export const homeContent = {
  mainTitle: 'Convenio Marco de Colaboración Académica, Científica y Tecnológica',
  mainDescription: 'El Instituto Tecnológico de Mexicali fue sede de la firma del Convenio Marco de Colaboración Académica, Científica y Tecnológica con el Instituto Tecnológico de Ciudad Juárez, el Instituto Tecnológico de Chihuahua II y el Centro de Estudios e Investigación para el Desarrollo Docente (CENID), el pasado 21 de agosto de 2025.',
  aboutCenid: 'El Centro de Estudios e Investigaciones para el Desarrollo Docente CENID, es una institución dedicada a la investigación interdisciplinaria, la docencia y la prestación de servicios técnicos, que tiene por objeto el abordaje de problemas relacionados con la educación, ciencia, la tecnología, la innovación, las estrategias de desarrollo y la educación superior en México e Iberoamérica.',
  participants: [
    'Dr. Manuel de Jesús López Pérez, Director del IT Mexicali',
    'Mtra. Gilda Peña Martínez, Subdirectora Académica del IT Mexicali',
    'Mtro. Gabriel Ernesto Pando Martínez, Subdirector de Planeación y Vinculación del IT Mexicali',
    'Mtro. Mario Macario Ruiz, Director del IT Ciudad Juárez',
    'Mtro. Eduardo Poblano, Subdirector Administrativo del IT Ciudad Juárez',
    'Dra. Susana Josefina Escárcega Castellanos, Directora del IT Chihuahua II',
    'Mtra. María Martínez, Subdirectora Académica del IT Chihuahua II',
    'Dr. Francisco Santillán Campos, Director General del CENID'
  ]
};

export const convocatorias = [
  {
    id: 1,
    title: 'Congresos internacionales virtuales y en diferido',
    description: 'Contamos con 7 diferentes temáticas',
    link: '/congresos'
  },
  {
    id: 2,
    title: 'Postdoctorado en educación',
    description: 'Programa de formación avanzada',
    link: '/postdoctorados'
  },
  {
    id: 3,
    title: 'Revistas electrónicas',
    description: 'Arbitradas, Científicas e Indexadas',
    link: '/revistas'
  },
  {
    id: 4,
    title: 'Redes de producción académica',
    description: 'Capítulos de libro y libros en extenso',
    link: '/redes'
  },
  {
    id: 5,
    title: 'Seminario de producción de textos académicos',
    description: 'Desarrollo de habilidades de escritura académica',
    link: '/seminarios'
  },
  {
    id: 6,
    title: 'Colección Editorial Cenid',
    description: 'Libros publicados por CENID',
    link: '/coleccion-editorial'
  }
];

export const contactInfo = {
  address: 'Centro de Estudios e Investigaciones para el Desarrollo Docente',
  city: 'México',
  phone: '+52 33 1061 8187',
  email: 'contacto@cenid.org',
  whatsapp: '+523310618187'
};

export const socialMedia = [
  { name: 'Facebook', url: '#', icon: 'Facebook' },
  { name: 'Twitter', url: '#', icon: 'Twitter' },
  { name: 'LinkedIn', url: '#', icon: 'Linkedin' },
  { name: 'YouTube', url: '#', icon: 'Youtube' }
];

export const quickLinks = [
  { name: 'Inicio', url: '/' },
  { name: 'Nosotros', url: '/nosotros' },
  { name: 'Formación', url: '/formacion' },
  { name: 'Congresos', url: '/congresos' },
  { name: 'Editorial CENID', url: '/editorial' },
  { name: 'Aviso de Privacidad', url: '/aviso-privacidad' }
];